export default __webpack_public_path__ + "static/media/lock.7f34536e.svg";